import { aboutData } from "@/mocks/homeData";

export default function AboutSection() {
  return (
    <section id="about" className="px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-950">
              关于我们
            </h2>
            <div className="mt-4 space-y-3">
              <p className="text-sm text-foreground-600 leading-relaxed max-w-[650px] mx-auto lg:mx-0">
                {aboutData.content}
              </p>
              <p className="text-sm text-foreground-600 leading-relaxed max-w-[650px] mx-auto lg:mx-0">
                {aboutData.content2}
              </p>
            </div>

            <div className="mt-6 flex flex-wrap items-center gap-4 md:gap-6 justify-center lg:justify-start">
              {aboutData.highlights.map((h) => (
                <div key={h.label} className="text-center">
                  <div className="text-lg md:text-2xl font-bold text-primary-500 font-heading whitespace-nowrap">
                    {h.value}
                  </div>
                  <div className="text-xs text-foreground-500 mt-0.5 whitespace-nowrap">
                    {h.label}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="shrink-0">
            <div className="w-full max-w-[400px] aspect-[4/3] rounded-lg overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20cozy%20home%20entertainment%20scene%20with%20large%20TV%20screen%20displaying%20cinematic%20content%2C%20soft%20ambient%20lighting%2C%20comfortable%20living%20room%20atmosphere%2C%20golden%20warm%20tones%2C%20modern%20interior%2C%20relaxing%20evening%20mood&width=800&height=600&seq=about-img-01&orientation=landscape"
                alt="关于6080影视"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}